import React from 'react'
import { Link, LinkProps } from 'react-router-dom-v5-compat'

const ExternalLinkBehavior = React.forwardRef<HTMLAnchorElement, LinkProps>(({ to = '/', ...props }, ref) => (
  <Link ref={ref} to={to} {...props} rel="noopener noreferrer" role={undefined} target="_blank" />
))

export default ExternalLinkBehavior
